import { render, staticRenderFns } from "./BestApartmentsBlock.vue?vue&type=template&id=0f079922&scoped=true&"
import script from "./BestApartmentsBlock.vue?vue&type=script&lang=js&"
export * from "./BestApartmentsBlock.vue?vue&type=script&lang=js&"
import style0 from "./BestApartmentsBlock.vue?vue&type=style&index=0&id=0f079922&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f079922",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f079922')) {
      api.createRecord('0f079922', component.options)
    } else {
      api.reload('0f079922', component.options)
    }
    module.hot.accept("./BestApartmentsBlock.vue?vue&type=template&id=0f079922&scoped=true&", function () {
      api.rerender('0f079922', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/BestApartmentsBlock.vue"
export default component.exports